module.exports = __webpack_public_path__ + "grass-instance-1.8fc247585fab78a480b2a8c8200a0a21.png";